import { render, staticRenderFns } from "./nonMerStep3.vue?vue&type=template&id=652d9a36&scoped=true&"
import script from "./nonMerStep3.vue?vue&type=script&lang=js&"
export * from "./nonMerStep3.vue?vue&type=script&lang=js&"
import style0 from "./nonMerStep3.vue?vue&type=style&index=0&id=652d9a36&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652d9a36",
  null
  
)

export default component.exports